/**
 * Formats a score to display exactly 1 decimal place.
 * @param value - The numeric score
 * @returns A string with exactly 1 decimal (e.g. "18.1", "85.0")
 */
export const formatScoreDisplay = (value: number): string => value.toFixed(1);

/**
 * Rounds a score to 1 decimal place, returning a number.
 * Use when passing to components that expect numeric values.
 * @param value - The numeric score
 * @returns A number rounded to 1 decimal (e.g. 18.1, 85)
 */
export const formatScoreValue = (value: number): number =>
  parseFloat(value.toFixed(1));
